import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow, TextInput, Label } from 'flowbite-react';

const StageManager = () => {
  const [stages, setStages] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const fetchStages = async () => {
    try {
      const response = await axios.get(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/stages`,
        { withCredentials: true },
      );
      setStages(response.data);
    } catch (error) {
      console.error('Error al cargar etapas:', error);
    }
  };

  useEffect(() => {
    fetchStages();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setIsSaving(true);
    try {
      const response = await axios.post(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/stage/create`,
        { name, description },
        { withCredentials: true },
      );
      setStages([response.data.stage, ...stages]);
      setName('');
      setDescription('');
    } catch (error) {
      console.error('Error al crear etapa:', error);
      alert('Error al crear etapa');
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (stageId) => {
    if (!window.confirm('¿Eliminar esta etapa?')) return;
    try {
      await axios.delete(
        `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/stage/${stageId}/delete`,
        { withCredentials: true },
      );
      setStages(stages.filter((s) => s.id !== stageId));
    } catch (error) {
      console.error('Error al eliminar etapa:', error);
      alert('Error al eliminar etapa');
    }
  };

  return (
    <div className="space-y-4">
      <form onSubmit={handleCreate} className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
        <div>
          <Label htmlFor="stage-name" value="Nombre de la etapa" />
          <TextInput
            id="stage-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="stage-description" value="Descripción (opcional)" />
          <TextInput
            id="stage-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div>
          <Button type="submit" isProcessing={isSaving} disabled={isSaving}>
            Agregar etapa
          </Button>
        </div>
      </form>

      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableHeadCell>Nombre</TableHeadCell>
            <TableHeadCell>Descripción</TableHeadCell>
            <TableHeadCell>
              <span className="srOnly">Acciones</span>
            </TableHeadCell>
          </TableHead>
          <TableBody className="divide-y">
            {stages.map((stage) => (
              <TableRow key={stage.id}>
                <TableCell className="font-medium text-gray-900">
                  {stage.name}
                </TableCell>
                <TableCell className="text-sm text-gray-700">
                  {stage.description || '-'}
                </TableCell>
                <TableCell>
                  <Button
                    size="xs"
                    color="failure"
                    onClick={() => handleDelete(stage.id)}
                  >
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {stages.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} className="text-center text-gray-500 py-4">
                  No hay etapas creadas.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default StageManager;

